<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click" @command="handleCommand">
        <div class="avatar-wrapper">
          <div v-if="name" class="user-title">{{ name }}</div>
          <img src="@/assets/profile.png" class="user-avatar">
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item command="profile"><i class="el-icon-user" /> 个人信息</el-dropdown-item>
          <el-dropdown-item command="password"><i class="el-icon-lock" /> 修改密码</el-dropdown-item>
          <el-dropdown-item divided command="logout"><i class="el-icon-switch-button" /> 退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import dragDialog from '@/directive/drag-dialog'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  directives: {
    dragDialog
  },
  data() {
    const validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.changeForm.confirmPass !== '') {
          this.$refs.changeForm.validateField('confirmPass')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.changeForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      dialogPassword: false,
      changeForm: {
        password: '',
        newPassword: '',
        confirmPass: ''
      },
      rules: {
        password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [{ required: true, validator: validatePass1, trigger: 'blur' }],
        confirmPass: [{ required: true, validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  computed: mapGetters(['sidebar', 'avatar', 'name', 'device']),
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async handleCommand(command) {
      if (command === 'profile') {
        this.$router.push('/profile')
      } else if (command === 'password') {
        this.dialogPassword = true
      } else if (command === 'logout') {
        try {
          const result = await this.$confirm('你确定要退出系统吗？', '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            customClass: 'exit-system',
            type: 'info'
          })
          if (result === 'confirm') {
            await this.$store.dispatch('user/logout')
            this.$router.push('/login')
          }
        } catch (error) {
          console.log(error)
        }
      }
    },
    changeFormSubmit() {
      this.$refs.changeForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch('user/resetPassword', this.changeForm).then(() => {
            this.$message({
              type: 'success',
              duration: 1500,
              message: '修改成功，请使用新密码重新登录',
              onClose: () => {
                this.dialogPassword = false
                this.$store.dispatch('user/logout').then(() => {
                  this.$router.push('/login')
                }).catch(() => {})
              }
            })
          }).catch(() => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  display: flex;
  overflow: hidden;
  position: relative;
  background: #fff;
  justify-content: space-between;
  // box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0 15px;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    flex: 1;
  }

  .right-menu {
    display: flex;
    align-items: center;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .avatar-container {
      display: flex;
      height: 100%;
      margin: 0 15px;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .user-title {
          margin-right: 8px;
          font-weight: 600;
          color: #606266;
        }
      }
    }
  }
}
.user-dropdown {
  margin-top: 5px;
}
</style>
